import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import { Link } from "gatsby"
import SocialLinks from "../../../constants/socialLinks"
import payment from "../../../images/payment-gateway-codebuilder.png"
import "./footer.css"
const Footer = () => {
  const d = new Date()
  let year = d.getFullYear()
  return (
    <div className="footer">
      <div className="footer-col ">
        <h3 className=" text-sm font-bold mb-4">Need Help?</h3>
        <p className="mb-1 text-xs">
          Call Us:{" "}
          <a href="tel:+8801934737162" className="font-bold">
            01934737162
          </a>
        </p>
        <p className="mb-1 text-xs">
          Email Us:{" "}
          <a
            href="mailto:gadgetstorebd123@gmail.com"
            className="font-bold underline"
          >
            Gadgetstorebd123@gmail.com
          </a>
        </p>
        <p className="mb-1 text-xs">
          Office Address:{" "}
          <span className="font-bold underline">
            House no : 20, Boundary Road : 03, Senpara Porbata Mirpur 2.
          </span>
        </p>
        <div>
          <SocialLinks styleClass="flex flex-row space-x-3" />
        </div>
      </div>
      <div className="footer-col">
        <h3 className="text-sm font-bold mb-4">We Accept</h3>
        <img src={payment} alt="payment gateway codebuilder" />
      </div>
      <div className="footer-col">
        <h3 className="text-sm font-bold mb-4">Related Page</h3>
        <p className="mb-1 text-xs">
          <Link to="/">Returns & Refunds Policy</Link>
        </p>
        <p className="mb-1 text-xs">
          <Link to="/">Terms & Conditon</Link>
        </p>
      </div>
      <div className="w-full h-px bg-slate-200 mx-4 my-4"></div>
      <div className="text-center ">
        <span className="text-xs">
          Copyright © {year} Gadget Store BD. All Rights Reserved. Design &amp;
          Developed by{" "}
          <a
            className="develop-by ml-3"
            href="http://codebuilderit.com/"
            target="_blank"
          >
            Code Builder IT
          </a>
        </span>
      </div>
    </div>
  )
}

export default Footer
